var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSublocationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C12.9 9 12 9.9 12 11C12 12.1 12.9 13 14 13C14.53 13 15.04 12.79 15.41 12.41C15.78 12.03 16 11.53 16 11C16 10.47 15.79 9.96 15.41 9.59C15.03 9.21 14.53 9 14 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 6.00005C15.9296 6.00005 18.9996 7.40005 18.9996 11.15C18.9996 13.31 17.2796 15.82 13.9996 18.47C10.7196 15.82 8.99961 13.3 8.99961 11.15C8.99961 7.40005 12.0696 6.00005 13.9996 6.00005ZM13.9996 4.00005C10.7296 4.00005 6.99961 6.46005 6.99961 11.15C6.99961 14.27 9.32961 17.56 13.9996 21C18.6696 17.56 20.9996 14.27 20.9996 11.15C20.9996 6.46005 17.2696 4.00005 13.9996 4.00005Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.53 18.02C10.35 18.17 10.19 18.32 10 18.47C6.72 15.82 5 13.3 5 11.15C5 8.02 7.13 6.53 8.96 6.12C9.82 5.24 10.89 4.63 12 4.3C11.34 4.1 10.66 4 10 4C6.73 4 3 6.46 3 11.15C3 14.27 5.33 17.56 10 21C10.73 20.46 11.38 19.93 12 19.4C11.46 18.94 10.98 18.48 10.53 18.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSublocationsActive);
export default __webpack_public_path__ + "static/media/icon-sublocations-active.20455d6b10bf79ee4224599623290352.svg";
export { ForwardRef as ReactComponent };